import React from 'react';

function BMITable({ classification }) {
    return (
        <table>
            <thead>
                <tr>
                    <th>Indice de masse corporelle (IMC)</th>
                    <th>État nutritionnel</th>
                </tr>
            </thead>
            <tbody>
                <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
                    <td>Moins de 18,5</td>
                    <td>Poids insuffisant (Underweight)</td>
                </tr>
                <tr className={classification === 'Normal weight' ? 'highlightedOk' : ''}>
                    <td>18,5–24,9</td>
                    <td>Poids normal (Normal weight)</td>
                </tr>
                <tr className={classification === 'Pre-obesity' ? 'highlightedWarning' : ''}>
                    <td>25,0–29,9</td>
                    <td>Surpoids (Pre-obesity)</td>
                </tr>
                <tr className={classification === 'Obesity class I' ? 'highlightedDanger' : ''}>
                    <td>30,0–34,9</td>
                    <td>Obésité grade I (Obesity class I)</td>
                </tr>
                <tr className={classification === 'Obesity class II' ? 'highlightedDanger' : ''}>
                    <td>35,0–39,9</td>
                    <td>Obésité grade II (Obesity class II)</td>
                </tr>
                <tr className={classification === 'Obesity class III' ? 'highlightedDanger' : ''}>
                    <td>40 ou plus</td>
                    <td>Obésité grade III (Obesity class III)</td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Source:</b>{' '}
                        <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                            Organisation mondiale de la santé (OMS)
                        </a>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Date de dernière révision:</b> 28/02/2026
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default BMITable;
